import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { MailRequestModel } from "src/app/Models/mailRequestModel.model";
import { SearchTypeModel } from "src/app/Models/AttachmentInfo.model";
import { AttachmentsModel } from "src/app/Models/attachments.model";
import { projectNamesModel } from "src/app/Models/projectInformation.model";

@Injectable({
  providedIn: "root",
})
export class ProjectService {
  httpOptions = {
    headers: new HttpHeaders({
      Accept: "application/json",
      Authorization: "Bearer " + localStorage.getItem("token"),
    }),
  };
  private ApiUrl = environment.apiUrl;
  private apiUrl = environment.apiUrl;
  constructor(private http: HttpClient) { }

  public getProject(projectId: string): Observable<any> {
    const url =
      this.apiUrl + "ProjectInformationHistory/SearchProject/" + projectId;
    return this.http.get<any>(url, this.httpOptions);
  }

  public getApprovedProject(projectId: string): Observable<any> {
    const url = this.apiUrl + "Project/SearchProject/" + projectId;
    return this.http.get<any>(url, this.httpOptions);
  }

  public updateApprovedProject(project: string): Observable<any> {
    const url = this.apiUrl + "Project/UpdateProject";
    return this.http.post<any>(url, project, this.httpOptions);
  }

  public getProjectsByStatus(status): Observable<any> {
    const url =
      this.apiUrl + "ProjectInformationHistory/GetProjectsByStatus/" + status;
    return this.http.get<any>(url, this.httpOptions);
  }
  public getProjectName(): Observable<projectNamesModel[]> {
    return this.http.get<projectNamesModel[]>(this.apiUrl + 'Project/GetProjectName')
  }
  public getProjectsByOrganization(
    from,
    size,
    status,
    organizationId
  ): Observable<any> {
    // tslint:disable-next-line: max-line-length
    const url =
      this.apiUrl +
      "ProjectInformationHistory/GetProjectsByOrganization/" +
      from +
      "/" +
      size +
      "/" +
      status +
      "/" +
      organizationId;
    return this.http.get<any>(url, this.httpOptions);
  }

  public getMostDownloadedProjects(): Observable<any> {
    const url = this.apiUrl + "Project/GetMostDownloadedProjects";
    return this.http.get<any>(url, this.httpOptions);
  }

  public getMostViewedProjects(): Observable<any> {
    const url = this.apiUrl + "Project/GetMostViewedProjects";
    return this.http.get<any>(url, this.httpOptions);
  }

  // public getAllProjects(from: number, size: number): Observable<any> {
  //   const url = this.apiUrl + 'Project/FetchAllProjects/' + +from + '/' + +size;
  //   return this.http.get<any>(url, this.httpOptions);
  // }

  public getAllProjects(
    from: number,
    size: number,
    organizationName: string = null
  ): Observable<any> {
    const url =
      this.apiUrl +
      "Project/FetchAllProjects/" +
      +from +
      "/" +
      +size +
      "/" +
      organizationName;
    return this.http.get<any>(url, this.httpOptions);
  }

  public updateViewCount(projectId: string) {
    const url = this.apiUrl + "Project/UpdateViewCount/" + projectId;
    return this.http.get<any>(url, this.httpOptions);
  }

  public updateDownloadCount(projectId: string) {
    const url = this.apiUrl + "Project/UpdateDownloadCount/" + projectId;
    return this.http.get<any>(url, this.httpOptions);
  }

  public getProjectsBySpeciality(speciality: string) {
    const url = this.apiUrl + "Project/GetProjectsBySpeciality/" + speciality;
    return this.http.get<any>(url, this.httpOptions);
  }

  public getProjectMetrics() {
    const url = this.apiUrl + "Project/GetProjectMetrics";
    return this.http.get<any>(url, this.httpOptions);
  }

  public getProjectCount(orgID: string) {
    const url = this.apiUrl + "Project/projectcount/" + orgID;
    return this.http.get<any>(url, this.httpOptions);
  }

  public getHistoryProjectCount(organizationId: string, status: string) {
    const url =
      this.apiUrl +
      "ProjectInformationHistory/GetHistoryProjectCount" +
      "/" +
      organizationId +
      "/" +
      status;
    return this.http.get<any>(url, this.httpOptions);
  }

  public getProjectsByCaseStudy(
    category: string,
    selectedOrganizationId: string, from: number, size: number
  ) {
    const url =
      this.apiUrl +
      "Project/GetProjectsByContentType/" +
      category +
      "/" +
      selectedOrganizationId + "?from=" + from + "&size=" + size;
    return this.http.get<any>(url, this.httpOptions);
  }

  uploadMultipleProjects(file): Observable<any> {
    const url = this.apiUrl + "Project/UploadMultipleProjects";
    const formData: FormData = new FormData();
    formData.append("Files", file, file.name);
    return this.http.post<any>(url, formData, this.httpOptions);
  }

  saveFile(uploads: Array<AttachmentsModel>): Observable<any> {

    const httpOptions = {
      headers: new HttpHeaders({
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      }),
    };
    httpOptions.headers.append("Content-Type", "multipart/form-data");
    const url = this.apiUrl + "File/file";
    const formData: FormData = new FormData();
    for (let index = 0; index < uploads.length; index++) {
      const attachment = uploads[index];
      if (attachment && attachment.file) {
        formData.append("Files", attachment.file, attachment.fileName);
      }
    }
    return this.http.post<any>(url, formData, httpOptions);
  }

  insertProject(projectInfo): Observable<any> {
    const url =
      this.apiUrl + "ProjectInformationHistory/CreateProjectInformationHistory";
    return this.http.post<any>(url, projectInfo, this.httpOptions);
  }

  insertProjectToApprovedList(projectInfo): Observable<any> {
    const url = this.apiUrl + "Project/CreateProject";
    return this.http.post<any>(url, projectInfo, this.httpOptions);
  }

  updateProject(projectInfo): Observable<any> {
    const url =
      this.apiUrl + "ProjectInformationHistory/UpdateProjectInformationHistory";
    return this.http.post<any>(url, projectInfo, this.httpOptions);
  }

  deleteProject(projectId): Observable<any> {
    const url = this.apiUrl + "Project/DeleteProject/" + projectId;
    return this.http.get<any>(url, this.httpOptions);
  }

  deleteHistoryDelete(projectId): Observable<any> {
    const url =
      this.apiUrl + "ProjectInformationHistory/DeleteProject/" + projectId;
    return this.http.get<any>(url, this.httpOptions);
  }
  public sendMail(mailObject: MailRequestModel): Observable<any> {
    const url = this.apiUrl + "Project/SendAttachments";
    return this.http.post<any>(url, mailObject, this.httpOptions);
  }

  public searchGrid(searchTerm: string, status: string): Observable<any> {
    const url =
      this.apiUrl +
      "ProjectInformationHistory/GridSearch/" +
      searchTerm +
      "/" +
      status;
    return this.http.get<any>(url, this.httpOptions);
  }

  public searchGridForApproved(
    searchTerm: string,
    organizationId: string,
    from: number,
    size: number
  ): Observable<any> {
    const url =
      this.apiUrl +
      "Project/GridSearch/" +
      searchTerm +
      "/" +
      organizationId +
      "?from=" +
      from +
      "&size=" +
      size;
    return this.http.get<any>(url, this.httpOptions);
  }

  public searchDoc(searchOptions: SearchTypeModel): Observable<any> {
    const url = this.apiUrl + "Project/Search";
    return this.http.post<any>(url, searchOptions, this.httpOptions);
  }

  public getSelectedFileRequests(url: string): Observable<any> {
    return this.http.get(url, {
      observe: "response" as "body",
      responseType: "blob",
    });
  }

  public deleteMultipleProjects(projectIds: string[]): Observable<any> {
    const url = this.apiUrl + "Project/DeleteMultipleProjects/";
    return this.http.post<any>(url, projectIds);
  }

  public getGetProjectMetrics(): Observable<any> {
    const url = this.apiUrl + "Project/GetProjectMetrics";
    return this.http.get(url, this.httpOptions);
  }

  public getProjectCodeAvailability(
    projectCode: string,
    deliveryOrganizationId: string
  ): Observable<any> {
    const url =
      this.apiUrl +
      "Project/GetProjectCodeAvailability/" +
      projectCode +
      "/" +
      deliveryOrganizationId;
    return this.http.get(url, this.httpOptions);
  }
}
